// extracted by mini-css-extract-plugin
export default {"container":"VendorButton_container__YK6Xr","selectedContainer":"VendorButton_selectedContainer__dw7Fz","text":"VendorButton_text__RGhfB"};